<template>
  <div>
    <template v-for="menu in item.items">
      <div
        v-if="menu.isSubmenu && haveValidChildren(menu)"
        :key="`submenu-${menu.id}`"
        class="navbar-item has-dropdown is-hoverable"
      >
        <a class="navbar-link">
          {{ menu.name }}
        </a>
        <div class="navbar-dropdown">
          <menu-bar :item="menu" />
        </div>
      </div>
      <component
        :is="'menu-bar-item'"
        v-if="!menu.isSubmenu && isAuthorized(menu.authorize)"
        :key="`menu-item-${menu.id}`"
        :item="menu"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import MenuBarItem from '@/components/shared/MenuBarItem.vue'

export default {
  name: 'MenuBar',
  components: {
    MenuBarItem
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    items() {
      return this.items || []
    },
    roles() {
      return this.bodega.roles.map((item) => item.id) || []
    }
  },

  methods: {
    isAuthorized(authorize = []) {
      if (authorize.length === 0) return true
      return this.roles.some((item) => authorize.includes(item))
    },
    haveValidChildren(menu = {}) {
      const items = menu.items || []
      return items.some((menu) =>
        this.roles.some((item) => menu.authorize.includes(item))
      )
    }
  }
}
</script>
